<template>
  <div>
    <div class="air__utils__heading">
      <div class="row">
        <div class="col-6 col-sm-8">
          <h5>Dashboard</h5>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
          <div class="mb-4">
            <h5 class="card-title">Stock Level of Products in Inventory</h5>
            <p class="lead font-size-14 card-subtitle">This data is calculated based on minimum stock level and maximum stock level defined by you.</p>
          </div>

          <div class="d-flex flex-row flex-wrap justify-content-between">

              <div class="card" style="background-color: #ffebee; width: 18rem;">
                  <div class="card-body">
                    <a @click="outofstock">
                      <dashboard-card
                        title="Out of Stock"
                        description="Total products"
                        :count=data.oos
                      />
                    </a>
                </div>
              </div>

              <div class="card" style="background-color: #fff9c4; width: 18rem;">
                <div class="card-body">
                  <a @click="reorderedstock">
                    <dashboard-card
                      title="Re-Order Stock"
                      description="Total products"
                      :count=data.reorder_stock
                    />
                  </a>
                </div>
              </div>

              <div class="card"  style="background-color: #c8e6c9; width: 18rem;">
                <div class="card-body">
                  <a @click="optimumstock">
                    <dashboard-card
                      title="Optimum Stock"
                      description="Total products"
                      :count=data.opt_stock
                    />
                  </a>
                </div>
              </div>

              <div class="card" style="background-color: #ffcdd2; width: 18rem;">
                <div class="card-body">
                  <a @click="highstock">
                    <dashboard-card
                      title="High Stock"
                      description="Total products"
                      :count=data.high_stock
                    />
                  </a>
                </div>
              </div>

          </div>

        <div>
          <div class="card" style="background-color: #90caf9;">
            <div class="card-body">
              <p class="lead text-dark">Total Inventory Products: {{data.total_products}}</p>
            </div>
          </div>
        </div>

        <div>
        </div>

        <div>
          <h5 class="px-4">Inventory Products List</h5>
          <stock-level-table
            v-if="outOfStockState"
            :data="products"
            :laoding="loading"
            @updateTable="outofstock"
          />

          <stock-level-table
            v-if="reOrderedState"
            :data="products"
            :laoding="loading"
            @updateTable="reorderedstock"
          />
          <stock-level-table
            v-if="optimumStockState"
            :data="products"
            :laoding="loading"
            @updateTable="optimumstock"
          />
          <stock-level-table
            v-if="highStockState"
            :data="products"
            :laoding="loading"
            @updateTable="highstock"
          />
        </div>

      </div>
    </div>

  </div>
</template>

<script>
import DashboardCard from '@/components/inventory/dashboard/index'
import StockLevelTable from '@/components/inventory/dashboard/StockLevelTable'

export default {
  // name: 'Inventory Dashboard',
  components: {
    DashboardCard,
    StockLevelTable,
  },
  mounted: function() {
    this.getInitData()
  },
  data: function() {
    return {
      loading: false,
      visible: false,
      data: [],
      products: [],
      meta: {},
      current: 1,
      pageSize: 10,
      outOfStockState: true,
      reOrderedState: false,
      optimumStockState: false,
      highStockState: false,
    }
  },
  methods: {
    getInitData() {
      console.log('Dashboard Initial')
      this.$http.get('/api/inventory/dashboard', {
        params: {
          limit: this.pageSize,
          page: this.current,
        },
      }).then(({ data }) => {
        this.loading = false
        this.data = data.data
        this.meta = data.meta
      })
    },
    clearStockStats() {
      this.outOfStockState = false
      this.reOrderedState = false
      this.optimumStockState = false
      this.highStockState = false
    },
    outofstock() {
      this.clearStockStats()
      this.outOfStockState = !this.outOfStockState
      this.loading = true
      this.$http.get('/api/inventory/product/stock/all?stock_level=OOS', {
        params: {
          limit: this.pageSize,
          page: this.current,
        },
      }).then(({ data }) => {
        this.loading = false
        this.products = data.data
        this.meta = data.meta
      })
    },
    reorderedstock() {
      this.clearStockStats()
      this.reOrderedState = !this.reOrderedState
      this.loading = true
      this.$http.get('/api/inventory/product/stock/all?stock_level=ROS', {
        params: {
          limit: this.pageSize,
          page: this.current,
        },
      }).then(({ data }) => {
        this.loading = false
        this.products = data.data
        this.meta = data.meta
      })
    },
    optimumstock() {
      this.clearStockStats()
      this.optimumStockState = !this.optimumStockState
      this.loading = true
      this.$http.get('/api/inventory/product/stock/all?stock_level=OPTS', {
        params: {
          limit: this.pageSize,
          page: this.current,
        },
      }).then(({ data }) => {
        this.loading = false
        this.products = data.data
        this.meta = data.meta
      })
    },
    highstock() {
      this.clearStockStats()
      this.highStockState = !this.highStockState
      this.loading = true
      this.$http.get('/api/inventory/product/stock/all?stock_level=HS', {
        params: {
          limit: this.pageSize,
          page: this.current,
        },
      }).then(({ data }) => {
        this.loading = false
        this.products = data.data
        this.meta = data.meta
      })
    },
  },
}
</script>
